// extracted by mini-css-extract-plugin
module.exports = {"trybesMenList":"TrybesMenList-module--trybesMenList--2QHdM","teamMember":"TrybesMenList-module--teamMember--22nX2"};